import { render, staticRenderFns } from "./laporana4.vue?vue&type=template&id=65b19c24&scoped=true&"
import script from "./laporana4.vue?vue&type=script&lang=js&"
export * from "./laporana4.vue?vue&type=script&lang=js&"
import style0 from "./laporana4.vue?vue&type=style&index=0&id=65b19c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b19c24",
  null
  
)

export default component.exports